import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";

const AddBundleModal = ({ show, handleClose, qnaId, onBundlesChange, bundle, mode }) => {
  const [formPercentage, setFormPercentage] = useState("");
  const [formMinutes, setFormMinutes] = useState("");
  const [errors, setErrors] = useState({
    formPercentage: "",
    formMinutes: "",
  });

  useEffect(() => {
    if (mode === "edit" && bundle) {
      setFormPercentage(bundle.percentage);
      setFormMinutes(bundle.minutes);
    } else {
      setFormPercentage("");
      setFormMinutes("");
    }
  }, [mode, bundle]);

  const modalHeaderStyle = {
    backgroundColor: "#292929",
    color: "#fff",
    padding: "20px",
  };

  const modalBodyStyle = {
    backgroundColor: "#292929",
    color: "#fff",
    padding: "20px",
  };

  const formControlStyle = {
    backgroundColor: "#444",
    color: "#fff",
    border: "none",
    padding: "10px",
  };

  const modalFooterStyle = {
    backgroundColor: "#292929",
    padding: "20px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    color: "#000",
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let formErrors = {};

    if (!formPercentage) {
      formErrors.formPercentage = "Percentage is required";
    } else if (formPercentage < 0) {
      formErrors.formPercentage = "Percentage cannot be negative";
    } else if (formPercentage > 100) {
      formErrors.formPercentage = "Percentage cannot be greater than 100";
    }

    if (!formMinutes) {
      formErrors.formMinutes = "Minutes are required";
    } else if (formMinutes < 0) {
      formErrors.formMinutes = "Minutes cannot be negative";
    }

    if (Object.keys(formErrors).length === 0) {
      setErrors({});
      const fData = {
        percentage: formPercentage,
        minutes: formMinutes,
      };

      const apiCall = mode === "edit"
        ? axios.put(`/api/admin/qna/${qnaId}/bundle/${bundle.id}`, fData)
        : axios.post(`/api/admin/qna/${qnaId}/bundle`, fData);

      axios.get("/sanctum/csrf-cookie").then((response) => {
        apiCall.then((res) => {
          if (res.data.status === 201 || res.data.status === 200) {
            swal("Success", res.data.message, "success");
            swal({
              title: "Success",
              text: res.data.message,
              icon: "success",
              timer: 1000,
              buttons: false,
            });
            setFormPercentage("");
            setFormMinutes("");
            onBundlesChange(res.data.bundle);
            handleClose();
          } else {
            setErrors(res.data.validation_errors);
          }
        });
      });
    } else {
      setErrors(formErrors);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton style={modalHeaderStyle}>
          <Modal.Title>{mode === "edit" ? "Edit Bundle" : "Add Bundle"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={modalBodyStyle}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formPercentage" style={{ marginBottom: "20px" }}>
              <Form.Label style={{ color: "#fff" }}>Discount Percentage</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter percentage"
                style={formControlStyle}
                value={formPercentage}
                onChange={(e) => setFormPercentage(e.target.value)}
                isInvalid={!!errors?.formPercentage}
                min={0}
                max={100}
                step={0.01}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.formPercentage || ""}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formMinutes" style={{ marginBottom: "20px" }}>
              <Form.Label style={{ color: "#fff" }}>Minutes</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter minutes"
                style={formControlStyle}
                value={formMinutes}
                onChange={(e) => setFormMinutes(e.target.value)}
                isInvalid={!!errors?.formMinutes}
                min={0}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.formMinutes || ""}
              </Form.Control.Feedback>
            </Form.Group>
            <Modal.Footer style={modalFooterStyle}>
              <Button variant="secondary" onClick={handleClose} style={{ padding: "10px 20px" }}>
                Cancel
              </Button>
              <Button
                type="submit"
                className="btn btnStatus fw-bold px-4 hover-btn"
                style={{ padding: "10px 20px", color: "#000" }}
              >
                {mode === "edit" ? "Update Bundle" : "Add Bundle"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddBundleModal;